<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 24 24" :class="[`${prefix}-icon`, `${prefix}-icon-ocr`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_f529c51ee6__a"><rect width="24" height="24" rx="0"/></clipPath></defs><g clip-path="url(#svg_f529c51ee6__a)"><path d="M2,8L3.5,8L3.5,6Q3.5,4.96447,4.2322299999999995,4.2322299999999995Q4.96447,3.5,6,3.5L8,3.5L8,2L6,2C3.79086,2,2,3.79086,2,6L2,8ZM16,3.5L18,3.5Q19.0355,3.5,19.7678,4.2322299999999995Q20.5,4.96447,20.5,6L20.5,8L22,8L22,6C22,3.79086,20.2091,2,18,2L16,2L16,3.5ZM2,18C2,20.2091,3.79086,22,6,22L8,22L8,20.5L6,20.5Q4.96447,20.5,4.2322299999999995,19.7678Q3.5,19.0355,3.5,18L3.5,16L2,16L2,18ZM16,20.5L16,22L18,22C20.2091,22,22,20.2091,22,18L22,16L20.5,16L20.5,18Q20.5,19.0355,19.7678,19.7678Q19.0355,20.5,18,20.5L16,20.5Z"/><path d="M7 9.75L17.000999999999998 9.75C17.4152 9.75 17.750999999999998 9.41421 17.750999999999998 9 17.750999999999998 8.585786 17.4152 8.25 17.000999999999998 8.25L7 8.25C6.585786 8.25 6.25 8.585786 6.25 9 6.25 9.41421 6.585786 9.75 7 9.75zM7 14.75L12.99999 14.75C13.414200000000001 14.75 13.74999 14.41421 13.74999 14 13.74999 13.585786 13.414200000000001 13.25 12.99999 13.25L7 13.25C6.585786 13.25 6.25 13.585786 6.25 14 6.25 14.41421 6.585786 14.75 7 14.75z" fill-rule="evenodd"/></g></svg>
</template>
<script>

export default {
  name: 'IconOcr',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
